import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Link } from '@mui/material';
import bibtexParse from 'bibtex-parse-js';
import { formatAuthors } from '../utils';

function Book() {
    const [entries, setEntries] = useState([]);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/books.bib`)
            .then((response) => response.text())
            .then((data) => {
                const parsed = bibtexParse.toJSON(data);
                setEntries(parsed);
            })
            .catch((error) => console.error('Error loading BibTeX file:', error));
    }, []);

    return (
        <Container>
            {entries.map((entry, index) => (
                <Card
                    key={index}
                    variant="outlined"
                    sx={{
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        padding: '10px',
                    }}
                >
                    <CardContent sx={{ flex: 1 }}>
                        {/* タイトル */}
                        <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            {entry.entryTags.title}
                        </Typography>

                        {/* 著者情報 */}
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {formatAuthors(entry.entryTags.author)}
                        </Typography>

                        {/* 著書の場合 */}
                        {entry.entryType === 'book' && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {entry.entryTags.publisher}, {entry.entryTags.year}
                            </Typography>
                        )}

                        {/* ブックチャプターの場合 */}
                        {entry.entryType === 'incollection' && (
                            <>
                                {/* チャプター番号 */}
                                {entry.entryTags.chapter && (
                                    <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                        Chapter: {entry.entryTags.chapter}
                                    </Typography>
                                )}
                                {/* ブック情報 */}
                                <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                    In: {entry.entryTags.booktitle}
                                    {entry.entryTags.editor && ` (Ed. ${entry.entryTags.editor})`}
                                    {entry.entryTags.publisher && `, ${entry.entryTags.publisher}`}
                                    {entry.entryTags.year && `, ${entry.entryTags.year}`}
                                    {entry.entryTags.pages && `, pp. ${entry.entryTags.pages}`}
                                </Typography>
                            </>
                        )}

                        {/* ISBN */}
                        {entry.entryTags.isbn && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                ISBN: {entry.entryTags.isbn}
                            </Typography>
                        )}

                        {/* DOI */}
                        {entry.entryTags.doi && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                DOI: <Link href={`https://doi.org/${entry.entryTags.doi}`} target="_blank" rel="noopener noreferrer">
                                    {entry.entryTags.doi}
                                </Link>
                            </Typography>
                        )}

                        {/* 外部リンク */}
                        {entry.entryTags.url && (
                            <Typography variant="body2">
                                <Link href={entry.entryTags.url} target="_blank" rel="noopener noreferrer">
                                    External Link
                                </Link>
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
        </Container>
    );
}

export default Book;
